import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import PropTypes from "prop-types";
import styles from "../styles";
GroupWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  colSpan: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  inputs: PropTypes.array
}; // Note: this is shared between <Edit> and <Preview> for displaying list(s) of inputs

export default function GroupWrapper(_ref) {
  var children = _ref.children,
      inputs = _ref.inputs,
      colSpan = _ref.colSpan,
      label = _ref.label;
  var flatInputs = flattenInputs(inputs);
  if (!flatInputs.filter(function (_ref2) {
    var inputs = _ref2.inputs;
    return !inputs;
  }).length) return null;
  if (children[0].props.passthroughProps.columnData) colSpan = 4;
  return /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    colSpan: colSpan,
    style: styles.sectionDivider
  }, label)), children);
}
export var flattenInputs = function flattenInputs(inputs, isCommercial) {
  if (isCommercial === void 0) {
    isCommercial = false;
  }

  return inputs.reduce(function (acc, input) {
    var supportedFusions = ["address", "location"];

    if (input.fusion && supportedFusions.includes(input.fusion)) {
      return [].concat(acc, [_extends({}, input, {
        inputs: flattenInputs(input.inputs, isCommercial)
      })]);
    }

    if (input.type === "group") {
      return [].concat(acc, flattenInputs(input.inputs, isCommercial));
    }

    if (input.type === "repeat") {
      return input.inputs.reduce(function (repeatAcc, repeatInputs) {
        return [].concat(repeatAcc, flattenInputs(repeatInputs, isCommercial));
      }, acc);
    }

    return [].concat(acc, [input]);
  }, []);
};